import React, { createContext, useReducer, useContext } from "react";
const CountContext = createContext();
const { Provider } = CountContext;

const reducer = (state, action) => {
  switch (action.type) {
    case 'hover':
      return {
        ...state,
        display: 'visible',
        name: action.name
      }
    case 'mouseOut':
      return {
        ...state,
        name: '',
        display: 'hidden'
      }
    case 'open':
      return {
        ...state,
        name: '',
        doorOpen: true,
        left: action.left,
        right: action.right,
        display: 'hidden',
        tipDisplay: 'none'
      }
    case 'close':
      return {
        ...state,
        doorOpen: false,
        left: 'closel',
        right: 'closer',
        home: 'none',
        project: 'projectContainer',
        tipDisplay: 'block',
        contact: true
      }
    case 'home':
      return {
        ...state,
        home: 'block',
        project: 'projectNav'
      }
    case 'contact':
      if (state.contact) {
        return {
          ...state,
          contact: false
        }
      } else {
        return {
          ...state,
          contact: true
        }
      }
    default:
      throw new Error(`Invalid action type: ${action.type}`);
  }
};

const CountProvider = ({ value = 0, ...props }) => {
  const [state, dispatch] = useReducer(
    reducer, {
    doorOpen: false,
    display: 'hidden',
    href: '',
    home: 'none',
    name: '',
    contact: false,
    project: 'projectContainer',
    tipDisplay: 'block'

  });

  return <Provider value={[state, dispatch]} {...props} />;
};

const useCountContext = () => {
  return useContext(CountContext);
};

export { CountProvider, useCountContext };

